export interface IUpdateSerologyDataRequest {
    id: number,
    organType: number,
    serologyMaxDaysBeforeSurgery: number,
    requiresQfg: number,
    serologyShipToId: number,
    serologyTests: number[]
}